import { Children, useEffect, useMemo, useState } from "react";
import { Box, Button, Chip, Stack, Tooltip, Typography } from "@mui/material";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextLogs } from "src/Contexts/Logs/LogsContext";
import { TableRowCore, TableCore, TdCore } from "src/Pages/components";
import { handleChipCoreCategories } from "src/Pages/components/CategoryComponentMap";
import { handleFormatDateDayWeek } from "src/shared/Utils/FormatDate/FormatDateToDayWeek";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { handleFormatDateIfIsNull } from "src/shared/Utils/handleFormatDateIfIsNull";
import { LogsDiffModal } from "../ModalLogs/LogsDiffModal";
import { FilterSidebarLogs } from "../FilterSidebar/FilterSidebar";
import { useHttpTableLogs } from "./hooks/useHttpTableLogs";
import { THeadLogs } from "./THead";
import { 
    getEntityLabel,
    getActionLabel,
    getActionColor,
 } from "src/Pages/TelasSistemas/Utils/LogsTranslate/LogsTranslate";

export const TableLogs = () => {
  const { valuesFilterLogs, listLogs } = useContextLogs();
  const { handleGet } = useHttpTableLogs();

  const { setNameSearch, itensPerPage, currentPage, nameSearch, attTable } =
    useConfigPageContext();

  const [openModal, setOpenModal] = useState(false);

  const [selectedLog, setSelectedLog] = useState<any>(null);

  const handleOpenModal = (log: any) => {
    setSelectedLog(log);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedLog(null);
  };

  useEffect(() => {
    handleGet({
      currentPage,
      itensPerPage,
      nameSearch,
      start_data: valuesFilterLogs.start_data,
      end_data: valuesFilterLogs.end_data,
      action: valuesFilterLogs.action,
      id_user: valuesFilterLogs.id_user,
    });
  }, [
    attTable,
    itensPerPage,
    currentPage,
    nameSearch,
    valuesFilterLogs.start_data,
    valuesFilterLogs.end_data,
    valuesFilterLogs.action,
    valuesFilterLogs.id_user,
  ]);

  const hasLogs = listLogs.length > 0;

  return (
    <>
      <TableCore
        THead={<THeadLogs />}
        filter={<FilterSidebarLogs />}
        qtdList={listLogs.length}
        setNameSearch={setNameSearch}
      >
        {hasLogs
          ? Children.toArray(
              listLogs.map((item) => {
                const fullDate = item.created_at
                  ? handleFormatDateDayWeek(
                      handleFormatDateIfIsNull(item.created_at),
                    )
                  : "-";

                const shortDate = item.created_at
                  ? FormatDateBR(item.created_at)
                  : "-";

                const userLabel = item.name_user
                  ? `${item.id_user} - ${item.name_user}`
                  : "Sistema";

                return (
                  <TableRowCore id={String(item.id)}>
                    <TdCore
                      values={
                        <Stack spacing={0.4}>
                          <Typography
                            sx={{
                              fontSize: 14,
                              fontWeight: 500,
                              color: "text.primary",
                            }}
                          >
                            {userLabel}
                          </Typography>

                          {!item.id_user && (
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "text.disabled",
                              }}
                            >
                              Ação automática
                            </Typography>
                          )}
                        </Stack>
                      }
                    />

                      <TdCore
                        values={
                            <Chip
                              label={getActionLabel(item.action).toUpperCase()}
                              size="small"
                              sx={{ padding: "0 6px", minWidth: "30px", backgroundColor: "#EFF8FF", color: "#0288D1"  }}
                            />}
                      />
                    <TdCore
                      values={
                        <Box sx={{ display: "flex", alignItems: "center", fontWeight: 430 }}>
                          {handleChipCoreCategories(getEntityLabel(item.entity).toUpperCase())}
                        </Box>
                      }
                    />


                    <TdCore
                      tooltip={fullDate}
                      textAlign="center"
                      values={
                          <Stack spacing={0.2}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: "text.primary",
                              }}
                            >
                              {shortDate}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "text.secondary",
                              }}
                            >
                              {fullDate}
                            </Typography>
                          </Stack>
                      }
                    />

                    <TdCore
                      values={
                        <Button
                          variant="text"
                          size="small"
                          startIcon={<VisibilityRoundedIcon />}
                          onClick={() => handleOpenModal(item)}
                          sx={{
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: "10px",
                            px: 1.2,
                          }}
                        >
                          Ver alteração
                        </Button>
                      }
                    />
                  </TableRowCore>
                );
              }),
            )
          : null}
      </TableCore>

      <LogsDiffModal
        open={openModal}
        onClose={handleCloseModal}
        data={selectedLog}
      />
    </>
  );
};
